import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { TabPanel as ReactTabPanel } from "react-tabs";
import { styled } from "@catchoftheday/theme";
import { boxStyleProps } from "../Box";
export var TabPanel = styled(ReactTabPanel)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), boxStyleProps);
TabPanel.tabsRole = "TabPanel";
export default TabPanel;